import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { ADD_USER } from '../../Utils/constant';
import { store } from '../../services/service';
import { useStoreUser } from '../../store/user';

export const AddUserForm = () => {
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const [select, setSelect] = useState()
    const [typeAgent, setTypeAgent] = useState()
    const users = useStoreUser()

    const submit = (data) => {
        setIsSubmit(true)
        store(ADD_USER, 'application/json', { ...data, role: select, typeAgent: typeAgent }).then((res) => {
            setIsSubmit(false);
            if (res.status === 200) {
                reset();
                users.user({ page: 0, param: "", size: 10 })
                toast.success('Utilisateur ajouté ')
                document.getElementById('fermer_create_trajet').click()
            }

        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err.response.data.donnee)
        })
    }

    useEffect(() => {
        reset()
    }, [reset])

    return (
        <div className=' '>
            <div className='flex item-center'>
                <h1 className="text-3xl font-mtn font-extrabold text-black">Création d'utilisateur</h1>
            </div>
            <form onSubmit={handleSubmit(submit)} className='px-2'>
                <div className=''>
                    <div className='grid grid-cols-3 gap-x-2 items-center'>
                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Nom et prenoms</label>
                            <input type="text" placeholder="ex : Yao kofff" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('nomPrenoms', { required: true })} />
                            {errors.nomPrenoms && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>
                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Username</label>
                            <input type="text" placeholder="ex : @yao" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('username', { required: true })} />
                            {errors.username && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>
                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Email</label>
                            <input type="text" placeholder="ex : kofi@yao.ee" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('email', { required: true })} />
                            {errors.email && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>

                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Role</label>
                            <select onChange={(e) => setSelect(e.target.value)} className="select select-bordered w-full h-10" >
                                <option disabled selected>Choisissez un role
                                </option>
                                {
                                    [
                                        { value: 'ROLE_ADMIN', label: 'Administrateur' },
                                        { value: 'ROLE_TECHNICIEN', label: 'Technicien' },
                                        { value: 'ROLE_COMMERCIALE', label: 'Commerciale' },
                                    ].map((item) => (
                                        <option value={item.value}>
                                            {item.label}
                                        </option>
                                    ))
                                }
                            </select>

                        </div>
                        {
                            select === 'ROLE_COMMERCIALE' ?
                                <div className='my-2'>
                                    <label htmlFor="" className='text-sm font-medium'>Type d'agent</label>
                                    <select onChange={(e) => setTypeAgent(e.target.value)} className="select select-bordered w-full h-10" >
                                        <option disabled selected>
                                            Selectionnez un type
                                        </option>
                                        <option value="COMMERCIAL_DOOR_TO_DOOR">
                                            Door to Door (Porte à porte)
                                        </option>
                                        <option value="COMMERCIAL_AGENCE">En agence</option>
                                    </select>
                                </div>

                                : null
                        }

                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Numéro de téléphone</label>
                            <input type="text" placeholder="ex : 002587663321" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('numero', { required: true })} />
                            {errors.numero && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>

                        <div className='my-2'>
                            <label htmlFor="" className='text-sm font-medium'>Mot de passe</label>
                            <input type="password" placeholder="ex : Palm ci" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                {...register('password', { required: true })} />
                            {errors.password && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                        </div>


                    </div>
                    <button type='submit'
                        disabled={isSubmit ? true : false}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                        {!isSubmit ? "Ajouter un utilisateur" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>
                </div>

            </form >
        </div>
    )
}
